import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import moment from "moment";

import { useForm, useFormValidation } from "../../../../hooks";

import { DateTimeInput, DiasSemanaSelector, IconButton, MedicamentoInput, NumberInput, ReactSelectSingleInput, ReactSelectSingleKeyInput, SwitchInput } from "../../..";

import { colors } from "../../../../types/types";

import styles from '../MultiFormMedicamentos.module.css';

export const MedicamentoForm = ({ element, formStatus='checked', onFormChange, removeElement }) => {

  const [tipoFrecuenciaReset, setTipoFrecuenciaResetFields] = useState(moment().unix());

  const [tipoDuracionReset, setTipoDuracionResetFields] = useState(moment().unix());

  const { medicamento, text, inicio, administracionPrescrita, modalidadPrescripcion, dosis, frecuencia, tipoFrecuencia, diasSemana, tipoDuracion, duracion, dosisRescate, contadorDosis, contadorDosisDisponibles, contadorDosisLimite, activo, onInputChange, onMultipleInputChange } = useForm({ medicamento: element.medicamento, text: element.text, inicio: element.inicio, administracionPrescrita: element.administracionPrescrita, modalidadPrescripcion: element.modalidadPrescripcion, dosis: element.dosis, frecuencia: element.frecuencia, tipoFrecuencia: element.tipoFrecuencia, diasSemana: element.diasSemana, tipoDuracion: element.tipoDuracion, duracion: element.duracion, dosisRescate: element.dosisRescate, contadorDosis: element.contadorDosis, contadorDosisDisponibles: element.contadorDosisDisponibles, contadorDosisLimite: element.contadorDosisLimite, activo: element.activo });

  const { isFormValid, formFields, startFormValidation, setFormFieldValidation, setMultipleFormFieldValidation } = useFormValidation([{field: 'medicamento', default: true}, {field: 'inicio', default: false}, {field: 'administracionPrescrita', default: true}, {field: 'modalidadPrescripcion', default: false}, {field: 'dosis', default: false}, {field: 'frecuencia', default: false}, {field: 'tipoFrecuencia', default: false}, {field: 'diasSemana', default: true}, {field: 'tipoDuracion', default: false}, {field: 'duracion', default: false}, {field: 'dosisRescate', default: true}, {field: 'contadorDosis', default: true}, {field: 'contadorDosisDisponibles', default: true}, {field: 'contadorDosisLimite', default: true}, {field: 'activo', default: true}]);

  useEffect(() => {
    if(onFormChange) onFormChange({ id: element.id, medicamento, text, inicio, administracionPrescrita, modalidadPrescripcion, dosis, frecuencia, tipoFrecuencia, diasSemana, tipoDuracion, duracion, dosisRescate, contadorDosis, contadorDosisDisponibles, contadorDosisLimite, activo, validation: isFormValid });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicamento, text, inicio, administracionPrescrita, modalidadPrescripcion, dosis, frecuencia, tipoFrecuencia, diasSemana, tipoDuracion, duracion, dosisRescate, contadorDosis, contadorDosisDisponibles, contadorDosisLimite, activo, isFormValid])

  useEffect(() => {
    if(formStatus === 'checking') startFormValidation();
  }, [formStatus, startFormValidation]);

  useEffect(() => {
    if(medicamento !== ''){
      startFormValidation();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let frecuenciaAux = '1';
    let tipoFrecuenciaAux = 'Horas';
    let tipoDuracionAux = 'Días';
    let dosisRescateAux = dosisRescate;
    if(modalidadPrescripcion === 'Con horario'){
      tipoFrecuenciaAux = 'Horas';
      if([1, 2, 4, 6, 8, 12, 24, 48, '1', '2', '4', '6', '8', '12', '24', '48'].includes(frecuencia)){
        frecuenciaAux = frecuencia;
      }else{
        frecuenciaAux = '1';
      }
    }
    if(modalidadPrescripcion === 'Días de la semana'){
      tipoFrecuenciaAux = 'Tomas al dia';
      if(frecuencia !== ''){
        frecuenciaAux = frecuencia;
      }else{
        frecuenciaAux = '1';
      }
    }
    if(modalidadPrescripcion === 'Periódica'){
      if(tipoFrecuencia !== '' && tipoFrecuencia !== 'Horas' && tipoFrecuencia !== 'Tomas al dia'){
        tipoFrecuenciaAux = tipoFrecuencia;
      }else{
        tipoFrecuenciaAux = 'Semanal';
      }
      if(frecuencia !== '1'){
        frecuenciaAux = frecuencia;
      }else{
        frecuenciaAux = '1';
      }
    }
    if(modalidadPrescripcion === 'Dosis única'){
      if(tipoFrecuencia !== '' && tipoFrecuencia !== 'Tomas al dia'){
        tipoFrecuenciaAux = tipoFrecuencia;
      }else{
        tipoFrecuenciaAux = 'Semanal';
      }
      if(frecuencia !== ''){
        frecuenciaAux = frecuencia;
      }else{
        frecuenciaAux = '1';
      }
    }
    if(modalidadPrescripcion === 'Razón Necesaria'){
      if(tipoFrecuencia !== '' && tipoFrecuencia !== 'Tomas al dia'){
        tipoFrecuenciaAux = tipoFrecuencia;
      }else{
        tipoFrecuenciaAux = 'Horas';
      }
      if(frecuencia !== ''){
        frecuenciaAux = frecuencia;
      }else{
        frecuenciaAux = '1';
      }
    }
    if(modalidadPrescripcion !== 'Con horario'){
      if(tipoDuracion !== '' && tipoDuracion !== 'Días'){
        tipoDuracionAux = tipoDuracion;
      }else{
        tipoDuracionAux = 'Semanas';
      }
    }else{
      tipoDuracionAux = tipoDuracion;
    }
    if(modalidadPrescripcion === 'Dosis única' || modalidadPrescripcion === 'Razón Necesaria'){
      dosisRescateAux = 'false';
    }
    onMultipleInputChange([{ target: { name: 'administracionPrescrita', value: !(modalidadPrescripcion === 'Razón Necesaria') } }, { target: { name: 'frecuencia', value: String(frecuenciaAux) } }, { target: { name: 'tipoFrecuencia', value: tipoFrecuenciaAux } }, { target: { name: 'tipoDuracion', value: tipoDuracionAux } }, { target: { name: 'dosisRescate', value: dosisRescateAux } }]);
    // onInputChange({ target: { name: 'administracionPrescrita', value: !(modalidadPrescripcion === 'Razón Necesaria') } });
    setMultipleFormFieldValidation([{ name: 'administracionPrescrita', value: true }, { name: 'frecuencia', value: true }, { name: 'tipoFrecuencia', value: true }, { name: 'tipoDuracion', value: true }, { name: 'dosisRescate', value: true }]);
    // setFormFieldValidation('administracionPrescrita', true);
    handleResetTipoFrecuancia();
    handleResetTipoDuracion();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalidadPrescripcion])
  
  const handleDeactivate = () => {
    onInputChange({ target: { name: 'activo', value: false } });
  }

  const handleResetTipoFrecuancia = () => {
    setTipoFrecuenciaResetFields(false);
    setTimeout(() => {
        setTipoFrecuenciaResetFields(true);
    }, 1);
  }

  const handleResetTipoDuracion = () => {
    setTipoDuracionResetFields(false);
    setTimeout(() => {
        setTipoDuracionResetFields(true);
    }, 1);
  }

  return (
    <div className={styles.medicamentoPanel}>
      <div className="row">
        <div className="col-md-12 col-lg-11">
          <MedicamentoInput
            defaultValue={text}
            disabled={(String(element.id).includes('|||nuevo|||')) ? false : true}
            formFieldStatus={ formFields['medicamento'].status }
            isClearable={true}
            label="Medicamento"
            name="medicamento"
            onChange={ onInputChange }
            onMultipleChange={ onMultipleInputChange }
            required={false}
            requiredIndicator={false}
            setFormFieldValidation={ setFormFieldValidation }
            value={medicamento}
          />
        </div>
        <div className={"col-md-12 col-lg-1"}>
          <div className={styles.closeBtnContainer}>
            <div>
              <label htmlFor="">&nbsp;</label>
              {(String(element.id).includes('|||nuevo|||'))
                ? <IconButton
                  icon="XCircle"
                  iconColor={colors.DANGER}
                  marginTop={false}
                  onClick={() => removeElement(element.id)}
                  type="button"
                  size={20}
                />
                : <IconButton
                  icon="XCircle"
                  iconColor={colors.DANGER}
                  marginTop={false}
                  onClick={() => handleDeactivate()}
                  type="button"
                  size={20}
                />
              }
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {(medicamento !== '') &&
        <div className="col">
          <ReactSelectSingleInput
            formFieldStatus={ formFields['modalidadPrescripcion'].status }
            label="Prescripción"
            name="modalidadPrescripcion"
            onChange={ onInputChange }
            required={true}
            requiredIndicator={true}
            setFormFieldValidation={ setFormFieldValidation }
            value={modalidadPrescripcion}
            values={['Con horario', 'Días de la semana', 'Periódica', 'Dosis única', 'Razón Necesaria']}
          />
        </div>
        }
      </div>
      <div className="row">
        {(medicamento !== '') &&
        <div className="col-md-6 col-lg">
          <DateTimeInput
            formFieldStatus={ formFields['inicio'].status }
            label={(String(element.id).includes('|||nuevo|||')) ? 'Fecha y hora de inicio' : 'Fecha y hora de reinicio'}
            name="inicio"
            onChange={ onInputChange }
            required={ true }
            requiredIndicator={ true }
            setFormFieldValidation={ setFormFieldValidation }
            value={ inicio }
          />
        </div>
        }
        {(medicamento !== '') &&
        <div className="col-md-6 col-lg">
          <NumberInput
            formFieldStatus={ formFields['dosis'].status }
            label="Dosis por toma"
            min={0}
            name="dosis"
            onChange={ onInputChange }
            required={ true }
            requiredIndicator={ true }
            setFormFieldValidation={ setFormFieldValidation }
            value={ dosis }
          />
        </div>
        }
        {(medicamento !== '' && (modalidadPrescripcion === 'Con horario' || modalidadPrescripcion === 'Periódica' || modalidadPrescripcion === 'Razón Necesaria' || modalidadPrescripcion === 'Días de la semana')) &&
        <div className="col-md-6 col-lg">
          {(modalidadPrescripcion === 'Con horario')
            ? <ReactSelectSingleInput
              formFieldStatus={ formFields['frecuencia'].status }
              label="Frecuencia de toma"
              name="frecuencia"
              onChange={ onInputChange }
              required={false}
              requiredIndicator={true}
              setFormFieldValidation={ setFormFieldValidation }
              value={ String(frecuencia) }
              values={['1', '2', '4', '6', '8', '12', '24', '48']}
            />
            : <NumberInput
              formFieldStatus={ formFields['frecuencia'].status }
              label="Frecuencia de toma"
              min={0}
              name="frecuencia"
              onChange={ onInputChange }
              required={ false }
              requiredIndicator={ true }
              setFormFieldValidation={ setFormFieldValidation }
              value={ frecuencia }
            />
          }
        </div>
        }
        {(medicamento !== '' && (modalidadPrescripcion === 'Con horario' || modalidadPrescripcion === 'Periódica' || modalidadPrescripcion === 'Razón Necesaria' || modalidadPrescripcion === 'Días de la semana') && tipoFrecuenciaReset) &&
        <div className="col-md-6 col-lg">
          {(modalidadPrescripcion === 'Con horario')
            ? <ReactSelectSingleKeyInput
              disabled={true}
              formFieldStatus={ formFields['tipoFrecuencia'].status }
              label=""
              name="tipoFrecuencia"
              onChange={ onInputChange }
              required={false}
              requiredIndicator={false}
              setFormFieldValidation={ setFormFieldValidation }
              value={ tipoFrecuencia }
              values={[{ value: 'Horas', label: 'Horas' }]}
            />
            : (modalidadPrescripcion === 'Razón Necesaria')
              ? <ReactSelectSingleKeyInput
                formFieldStatus={ formFields['tipoFrecuencia'].status }
                label=""
                name="tipoFrecuencia"
                onChange={ onInputChange }
                required={false}
                requiredIndicator={false}
                setFormFieldValidation={ setFormFieldValidation }
                value={ tipoFrecuencia }
                values={[{ value: 'Horas', label: 'Horas' }, { value: 'Semanal', label: 'Semana(s)' }, { value: 'Mensual', label: 'Mes(es)' }]}
              />
              : (modalidadPrescripcion === 'Días de la semana')
                ? <ReactSelectSingleKeyInput
                  disabled={true}
                  formFieldStatus={ formFields['tipoFrecuencia'].status }
                  label=""
                  name="tipoFrecuencia"
                  onChange={ onInputChange }
                  required={false}
                  requiredIndicator={false}
                  setFormFieldValidation={ setFormFieldValidation }
                  value={ tipoFrecuencia }
                  values={[{ value: 'Tomas al dia', label: 'Tomas al dia' }]}
                />
                : <ReactSelectSingleKeyInput
                  formFieldStatus={ formFields['tipoFrecuencia'].status }
                  label=""
                  name="tipoFrecuencia"
                  onChange={ onInputChange }
                  required={false}
                  requiredIndicator={false}
                  setFormFieldValidation={ setFormFieldValidation }
                  value={ tipoFrecuencia }
                  values={[{ value: 'Semanal', label: 'Semana(s)' }, { value: 'Mensual', label: 'Mes(es)' }]}
                />
          }
        </div>
        }
      </div>
      <div className="row mb-2">
        {(medicamento !== '' && modalidadPrescripcion === 'Días de la semana') &&
        <div className="col">
          <DiasSemanaSelector
              formFieldStatus={ formFields['diasSemana'].status }
              label="Selección de días"
              name="diasSemana"
              onChange={ onInputChange }
              required={ false }
              requiredIndicator={ true }
              setFormFieldValidation={ setFormFieldValidation }
              value={ diasSemana }
          />
        </div>
        }
      </div>
      <div className="row">
        {(medicamento !== '' && !(modalidadPrescripcion === 'Dosis única' || modalidadPrescripcion === 'Razón Necesaria') && tipoDuracion !== 'Sin suspender') &&
        <div className="col">
          <NumberInput
            formFieldStatus={ formFields['duracion'].status }
            label="Duración"
            min={0}
            name="duracion"
            onChange={ onInputChange }
            required={ true }
            requiredIndicator={ true }
            setFormFieldValidation={ setFormFieldValidation }
            value={ duracion }
          />
        </div>
        }
        {(medicamento !== '' && !(modalidadPrescripcion === 'Dosis única' || modalidadPrescripcion === 'Razón Necesaria') && tipoDuracionReset) &&
        <div className="col">
          {(modalidadPrescripcion === 'Con horario')
            ? <ReactSelectSingleInput
              formFieldStatus={ formFields['tipoDuracion'].status }
              label={(tipoDuracion === 'Sin suspender') ? 'Duración' : ''}
              name="tipoDuracion"
              onChange={ onInputChange }
              required={false}
              requiredIndicator={(tipoDuracion === 'Sin suspender') ? true : false}
              setFormFieldValidation={ setFormFieldValidation }
              value={ tipoDuracion }
              values={['Días', 'Semanas', 'Meses', 'Sin suspender']}
            />
            : <ReactSelectSingleInput
              formFieldStatus={ formFields['tipoDuracion'].status }
              label={(tipoDuracion === 'Sin suspender') ? 'Duración' : ''}
              name="tipoDuracion"
              onChange={ onInputChange }
              required={false}
              requiredIndicator={(tipoDuracion === 'Sin suspender') ? true : false}
              setFormFieldValidation={ setFormFieldValidation }
              value={ tipoDuracion }
              values={['Semanas', 'Meses', 'Sin suspender']}
            />
          }
        </div>
        }
      </div>
      <div className="row">
        {(medicamento !== '' && modalidadPrescripcion !== 'Dosis única' && modalidadPrescripcion !== 'Razón Necesaria') &&
        <div className="col-md-6 col-lg">
          <SwitchInput
            checked={ (dosisRescate === 'true' || dosisRescate === true) ? true : false }
            label='¿Dosis de rescate?'
            labelPosition='start'
            name='dosisRescate'
            onChange={onInputChange}
          />
        </div>
        }
        {(medicamento !== '') &&
        <div className="col-md-6 col-lg">
          <SwitchInput
            checked={ (contadorDosis === 'true' || contadorDosis === true) ? true : false }
            label='Contador de dosis'
            labelPosition='start'
            name='contadorDosis'
            onChange={onInputChange}
          />
        </div>
        }
        {(medicamento !== '' && (contadorDosis === 'true' || contadorDosis === true)) &&
        <div className="col-md-6 col-lg">
          <NumberInput
            formFieldStatus={ formFields['contadorDosisDisponibles'].status }
            label="Dosis disponibles"
            min={0}
            name="contadorDosisDisponibles"
            onChange={ onInputChange }
            required={ false }
            requiredIndicator={ false }
            setFormFieldValidation={ setFormFieldValidation }
            value={ contadorDosisDisponibles }
          />
        </div>
        }
        {(medicamento !== '' && (contadorDosis === 'true' || contadorDosis === true)) &&
        <div className="col-md-6 col-lg">
          <NumberInput
            formFieldStatus={ formFields['contadorDosisLimite'].status }
            label="Límite de dosis para alerta"
            min={0}
            name="contadorDosisLimite"
            onChange={ onInputChange }
            required={ false }
            requiredIndicator={ false }
            setFormFieldValidation={ setFormFieldValidation }
            value={ contadorDosisLimite }
          />
        </div>
        }
      </div>
    </div>
  )
}

MedicamentoForm.propTypes = {
  element: PropTypes.any.isRequired,
  formStatus: PropTypes.oneOf(['checked', 'checking']),
  onFormChange: PropTypes.func,
  removeElement: PropTypes.func.isRequired,
}